import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSideMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTSideMenu');
});
var bootStrapSideMenu = function (props) {
    return (React.createElement(BootStrapSideMenu, __assign({}, props)));
};
var SideMenu = function (props) {
    var componentToDisplay = bootStrapSideMenu(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapSideMenu(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
SideMenu.defaultProps = {
    items: '',
    depth: 0,
    depthStep: 10,
    expanded: '',
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(SideMenu);
//# sourceMappingURL=SideMenu.js.map